import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { TradeModuleClass } from './module';

export const tradeModule = getModule(TradeModuleClass, store);
export * from './types';
